import { cloneDeep } from 'lodash'

export const mapListOnStatus = list =>
    list.reduce((acc, [id, info]) => {
        if (!acc[info.status]) {
            acc[info.status] = [info]
        } else {
            acc[info.status].push(info)
        }
        return acc
    }, {})

export const defineMeasure = num => {
    const len = num.toString().length

    if (len <= 6) {
        return Math.trunc(num / 1024) + ' KB'
    } else if (len <= 8) {
        return (num / 1024 / 1024).toFixed(1) + ' MB'
    }

    return null
}

export const getFileNameAndExt = value => {
    const parts = value.split('.')

    if (parts.length >= 2) {
        const ext = parts.pop()
        const filename = parts.join()

        return { filename, ext }
    }

    return { filename: value, ext: '' }
}

export const mapUnsplashImages = unsplashImages => {
    const newUnsplashImages = cloneDeep(unsplashImages)

    newUnsplashImages.content = unsplashImages.content.map(item => {
        return {
            id: item.id,
            originalImageId: item.id,
            name: '',
            authorInfo: item.user,
            url: item.urls.thumb,
            previewUrl: item.urls.regular,
        }
    })

    return newUnsplashImages
}

const getNormalImageUrl = (originalImageId, normalImages) => {
    const [{ url = '' } = {}] = normalImages.content.filter(
        normalItem => normalItem.originalImageId === originalImageId,
    )
    return url
}
